export function generateCodeVerifier(): string {
	const uint8Array: Uint8Array = new Uint8Array(32);
	window.crypto.getRandomValues(uint8Array);
	return base64URLEncode(String.fromCharCode.apply(null, Array.from(uint8Array)));
}

export async function generateCodeChallenge(codeVerifier: string): Promise<string> {
	return sha256(codeVerifier).then(value => {
		return base64URLEncode(value);
	});
}

function base64URLEncode(value: string): string {
	return btoa(value).replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
}

async function sha256(data: any): Promise<string> {
	const msgUint8 = new TextEncoder().encode(data);
	const hashBuffer = await crypto.subtle.digest('SHA-256', msgUint8);
	const hashArray = Array.from(new Uint8Array(hashBuffer));
	return String.fromCharCode.apply(null, hashArray);
}

